import React, { memo } from "react";
import { Detail } from "../../templates";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { routesName, useGetAdminUsersList, useNavigation } from "core";

const UserDetail = memo(() => {
  const { i18n } = useTranslation();
  const { id } = useParams();
  const { _navigateWithParams } = useNavigation();

  const { data,isFetching } = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "1",
    userId: id,
  });

  return (
    <>
      <Detail
        isLoading={isFetching}
        title={i18n.t("userDetail")}
        data={data?.data?.users}
        onClick={() => {
          _navigateWithParams(routesName.EDITUSER, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { UserDetail };
